import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MyFilesView from './Views/MyFilesView/MyFilesView';
import AdminView from './Views/AdminView/AdminView';
import AdminUserView from './Views/AdminUserView/AdminUserView';
import AdminStoresView from './Views/AdminStoresView/AdminStoresView';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<MyFilesView />} />
                <Route path="/admin" element={<AdminView />} />
                <Route path="/admin/users" element={<AdminUserView />} />
                <Route path="/admin/stores" element={<AdminStoresView />} />
            </Routes>
        </Router>
    );
}

export default App;
